import CallHangupIcon from 'crono-fe-common/icons/CallHangupIcon';

export const HangupButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      className="mt-8 bg-red-500 text-white rounded-full size-14 grid place-content-center cursor-pointer border-none hover:bg-red-600"
      title="Hang up call"
      onClick={onClick}
    >
      <CallHangupIcon />
    </button>
  );
};
